<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-auto">
        <el-form-item
          :label="L10n('image')"
          prop="image"
          data-filed="true"
          :rules="getValidationRule('required')"
          class="material-style">
          <br/>
          <image-uploader
            style="width: 16rem"
            :model.sync="form.image"
            :label="L10n('change-image')"/>
        </el-form-item>
      </div>
      <div class="col" style="max-width: 500px">
        <el-form-item
          :label="L10n('title')"
          prop="title"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.title"
            @input="form.title = valueTrimLeft($event)"
            @change="updateModelItem('title', { required: true })"/>
        </el-form-item>
        <el-form-item
          :label="L10n('sub-title')"
          prop="subTitle"
          class="material-style">
          <el-input
            :value="form.subTitle"
            @input="form.subTitle = valueTrimLeft($event)"
            @change="updateModelItem('subTitle', { required: false })"/>
        </el-form-item>
        <el-form-item
          :label="L10n('link-URL')"
          prop="linkURL"
          :rules="getValidationRule('required,url')"
          class="material-style">
          <el-input
            :value="form.linkURL"
            @input="form.linkURL = valueTrimLeft($event)"
            @change="updateModelItem('linkURL', { required: true })"/>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormLabel',
  mixins: [Form]
}
</script>
